import { motion } from 'framer-motion'
import React from 'react'

const animations = {
    initial: { opacity: 0, x: -10 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
}
export default function AnimatedPage({ children,classKey }) {
    return (
        <motion.div
            variants={animations}
            initial="initial"
            animate="animate"
            exit="exit"
            className={classKey?classKey:''}
            transition={{ duration: 0.15 }}>
            {children}
        </motion.div>
    )
}